<template>
    <div>
        <main class="app-content">
      
      <div class="row">     
        <div class="col-md-12">
          <div class="tile">     
            <v-row justify="center" no-gutters>
              <v-col cols="11"></v-col>
              <v-col cols="1" >
                  <v-btn color="error" dark rounded elevation="2" @click="$router.go(-1)"><v-icon color="white">mdi-close-circle</v-icon></v-btn>
              </v-col>
            </v-row>    
            <div class="tile-body">  
               <v-row v-if="transaccion.idpersona">
                 <div id="cliente" class="col-md-12">
                  <v-row>
                    <v-col cols="2">
                      <v-autocomplete
                          :items="categorias"
                          v-model="editedItem.idcategoria"
                          dense
                          color="#17a2b8"
                          outlined
                          clearable
                          hide-details
                          hide-selected
                          item-text="categoria"
                          item-value="idcategoria"
                          label="Seleccione Tipo"        
                          autofocus    
                      >
                      <template v-slot:no-data>
                          <v-list-item>
                          <v-list-item-title>
                              <strong>No se contro ningun registro</strong>
                          </v-list-item-title>
                          </v-list-item>
                      </template>          
                      </v-autocomplete>  
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="editedItem.descripcion" label="Descripcion" color="teal" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-text-field v-model="editedItem.cantidad" label="Cantidad" color="teal" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="1"> 
                        <v-text-field v-model="editedItem.precio" label="Precio" color="teal" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-text-field label="Total" color="teal" required :value="editedItem.cantidad*editedItem.precio" outlined dense readonly></v-text-field>
                    </v-col>
                    <v-col cols="1">
                    <v-btn fab dark small color="pink" @click="save" v-show="(editedItem.cantidad*editedItem.precio)>0">
                      <v-icon dark>
                        mdi-plus
                      </v-icon>
                    </v-btn>

                    </v-col>
                  </v-row>                  
                 </div>
                 <div id="transacciondetalles" class="col-md-12" >
                  <v-row>
                   
                    <v-col cols="12">
                      <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Categoria</th>
                            <th class="text-left">
                              Descripcion
                            </th>
                            <th>Cantidad</th>
                            <th class="text-left">
                              Precio
                            </th>
                            <th>
                              Total
                            </th>
                            <th>Opciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in transaccionItems"
                            :key="item.index" >
                            <td>{{ getNameCategoria(item) }}</td>
                            <td width="40%">{{ item.descripcion }}</td>
                            <td>{{ item.cantidad }}</td>
                            <td>{{ item.precio }}</td>
                            <td>{{ item.precio*item.cantidad }}</td>
                            <td><v-btn icon color="pink" @click="popDetail(item)"> <v-icon>mdi-delete-forever</v-icon></v-btn></td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="3"></td>
                            <td colspan="2"> <h4>Total</h4> </td>
                            <td><h4>Q {{calculoTotales}}</h4></td>
                          </tr>
                        </tfoot>
                      </template>
                    </v-simple-table>
                    </v-col>
                  </v-row>
                  <div class="float-right  mr-10">
                    <hr>
                   <v-btn rounded color="green" dark v-show="transaccion.total>0" @click="postTransaccion">Pagar</v-btn>
                  </div>
                  
                 </div>

               </v-row>
               <!-- SINO SE HA SELECCIONADO CONTRIBUYENTE-->
               <v-row v-else>
                 <v-col>
                    <h3><v-icon class="teal--text mdi-48px">mdi-arrow-up-bold-circle-outline</v-icon>Primero debe seleccionar un Contribuyente</h3>
                 </v-col>
               </v-row>
            </div>
          </div>
        </div>
      </div>
    </main>

    </div>
</template>
<script>
import axios from "axios";
import Swal from 'sweetalert2'
import currency from '@/libs/currency'
import moment from 'moment'
export default {
    name:'TransaccionDetalle',
    data() {
        return {
            titlerouter:'Control de Pagos',
            clientes:[],
            categorias:[],
            transaccionItems:[],
            editedIndex: -1,
            headers: [
            { text: 'Cantidad', value: 'cantidad' },
            { text: 'Descripcion ', value: 'descripcion' },
            { text: 'Precio', value: 'precio' },
            { text: 'Total', value: 'total'},
            { text: 'Opciones', value: 'actions', sortable: false },
            ],
        //Transaccion    
        transaccion:{
          codigo:'',
          fecha:moment().format('YYYY-MM-DD'),
          idpersona:this.$store.getters.getCliente,
          idusuario:this.$store.getters.getCurrentUser.IdUsuario,
          descuento:0,
          total:'',
          tipo:'Ingreso',
        },
        cleartransaccion:{
          codigo:'',
          fecha:moment().format('YYYY-MM-DD'),
          idpersona:this.$store.getters.getCliente,
          idusuario:this.$store.getters.getCurrentUser.IdUsuario,
          descuento:0,
          total:0,
          tipo:'Ingreso',
        },   
        //DetallesTransaccion 
        editedItem: {
          cantidad:1,
          precio:0,
          periodo:'',
          descripcion:'',
          idcategoria:1,
          idtransaccion:'',
        },
        defaultItem: {
          cantidad:1,
          precio:0,
          periodo:'',
          descripcion:'',
          idcategoria:1,
          idtransaccion:'',
        },       
       }
    },
    created() {
        this.getCategorias()
    },
    computed: {      
        inputvalidos(){
            if(this.editedItem.Nombre.length>5 && this.editedItem.Clave.length>5 && this.editedItem.Login.length>5){
                return  true
            }
            return false
        },
        calculoTotales(){
          return this.calculos()
        }
    },
    methods: {
        getCategorias(){
            axios.get(`${this.$store.state.urlapi}/pagos/categorias`,{headers:{'auth-user':this.$store.getters.getToken}})
            .then(response=>{
                if(response.data.length>0){
                    this.categorias = response.data;
                }
            }).catch(error=>{
                console.log(error)
            })     
        },
        //Calculos
        calculos(){
          this.transaccion.total = currency(this.transaccionItems.reduce((acumulado,item)=>acumulado+parseFloat(item.cantidad*item.precio),0),2).value
          this.codigotransaccion()
          return this.transaccion.total 
        },
        //GenerarCodigo
        codigotransaccion(){
          let result = ''
          let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          for ( let i = 0; i < 6; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * characters.length));
          }
          this.transaccion.codigo=result
        },
        editItem(item) {  
          this.editedIndex = this.dataitems.indexOf(item)       
          this.editedItem = Object.assign({}, item)      
        },
        async postTransaccion(){          
          axios.post(`${this.$store.state.urlapi}/pagos/transaccion`,this.transaccion,{headers:{'auth-user':this.$store.state.token}}).then(response=>{
            if(response.status==200){
              this.postTransaccionItems(response.data.insertId)
            }
            }).catch(error=>{
                console.log(error)
                this.errorSwal()
            })         
        },
        async postTransaccionItems(insertId){
          this.transaccionItems.forEach(element => {
            element.idtransaccion =insertId
            axios.post(`${this.$store.state.urlapi}/pagos/transacciondetalle`,element,{headers:{'auth-user':this.$store.state.token}})
          });
          this.$router.go(-1)
          this.exitoSwal()
        },
        pushDetail(){
          this.transaccionItems.push(this.editedItem)
        },
        popDetail(item){
          let indice = this.transaccionItems.indexOf(item)
          this.transaccionItems.splice(indice,1)
        },
        //Obtenemos el nombre de la categoria por su idcategoria
        getNameCategoria(item){
          let dato = this.categorias.find(elemento =>{return elemento.idcategoria === item.idcategoria})
          return dato.categoria
        },
        
        editarRegistro(){
            const id = this.editedItem.IdPermiso
            axios.put(`${this.$store.state.urlapi}/pagos/transaccion/${id}`,this.editedItem,{headers:{'auth-user':this.$store.state.token}}).then(()=>{
                this.getItems()
                this.exitoSwal()
            }).catch(error=>{
                console.log(error)
                this.errorSwal()
            })
        },
        close () {
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          })
        },
        save () {
          if (this.editedIndex > -1) {
                this.editarRegistro();
          } else {
            this.pushDetail()
               // this.guardarRegistro(); 
          }
          this.close()
        },
        
        //NOTIFICACIONES SWAL ALERT
        exitoSwal(){
            Swal.fire({
                icon: 'success',
                title: '¡Realizado!',
                showConfirmButton: false,
                timer: 1500
            })
        },
        errorSwal(){
            Swal.fire({
                icon: 'error',
                title: 'Ocurrio un Error :(',
                text:'Si el error persiste contacte a soporte técnico'
            })
        }
    },
}
</script>

<style scoped>
a{
text-decoration: none;
}
.Bold { font-weight: bold; }
p{
 margin :0 0 0 0; 
 padding: 0;
}
</style>